export default __webpack_public_path__ + "static/media/sd10.14485292.png";